import React, { useState, useEffect } from "react";
import { Table, Card } from "antd";
import dayjs from "dayjs";

// Marketplace List
const MARKETPLACES = [
  "Blibli",
  "Lazada",
  "Shopee",
  "Tokopedia",
  "TikTok",
  "Website",
  "Manual/affiliator",
];

const PERIOD_LABELS = {
  PERIOD: "Sales periode yg dipilih",
  MTD: "total MTD",
  YTD: "total YTD",
};

const buildTableData = (rawData) => {
  // Defensive: always array
  const data = Array.isArray(rawData) ? rawData : [];

  // Get all unique marketplaces from the data
  const allMarketplaces = [
    ...new Set(data.map((d) => d._id).filter(id => id && id !== "ALL")),
    ...MARKETPLACES // Include predefined marketplaces even if no data
  ];
  const uniqueMarketplaces = [...new Set(allMarketplaces)];

  // Initialize rows for each marketplace
  const tableRows = uniqueMarketplaces.map((marketplace) => {
    // Find each period for this marketplace
    const row = { key: marketplace, marketplace };

    Object.keys(PERIOD_LABELS).forEach((period) => {
      const found = data.find(
        (d) =>
          (d._id || "").toLowerCase() === marketplace.toLowerCase() &&
          d.Period === period
      );
      row[`${period}_qty`] = found ? found.QTY : "";
      row[`${period}_value`] = found ? found.Value : "";
      row[`${period}_pricepoint`] = found ? Math.round(found.PricePoint) : "";
    });
    return row;
  });

  // Grand total row: where _id is null for each period
const grandTotalRow = { key: "Grand Total", marketplace: "Grand Total" };
Object.keys(PERIOD_LABELS).forEach((period) => {
  // Get all data for this period
  const periodRows = data.filter(
    (d) => d.Period === period && d._id !== null && d._id !== "ALL"
  );

  const qtySum = periodRows.reduce((sum, d) => sum + (d.QTY || 0), 0);
  const valueSum = periodRows.reduce((sum, d) => sum + (d.Value || 0), 0);
  // Weighted price point: (total value / total qty) or 0 if qtySum is 0
  const pricePoint = qtySum > 0 ? Math.round(valueSum / qtySum) : "";

  grandTotalRow[`${period}_qty`] = qtySum || "";
  grandTotalRow[`${period}_value`] = valueSum || "";
  grandTotalRow[`${period}_pricepoint`] = pricePoint;
});

  return [...tableRows, grandTotalRow];
};

// Table column definitions with grouped headers
const aggEcomColumns = [
  {
    title: <b>MARKET PLACE</b>,
    dataIndex: "marketplace",
    key: "marketplace",
    fixed: "left",
    width: 170,
    render: (v, row) =>
      row.marketplace === "Grand Total" ? (
        <b style={{ color: "#215623" }}>{v}</b>
      ) : (
        v
      ),
  },
  ...Object.entries(PERIOD_LABELS).map(([period, label]) => ({
    title: <span style={{ fontWeight: 600 }}>{label}</span>,
    children: [
      {
        title: "QTY",
        dataIndex: `${period}_qty`,
        key: `${period}_qty`,
        align: "right",
        render: (v) => (v ? v.toLocaleString("id-ID") : ""),
      },
      {
        title: "Value",
        dataIndex: `${period}_value`,
        key: `${period}_value`,
        align: "right",
        render: (v) => (v ? `Rp ${v.toLocaleString("id-ID")}` : ""),
      },
      {
        title: "Price Point",
        dataIndex: `${period}_pricepoint`,
        key: `${period}_pricepoint`,
        align: "right",
        render: (v) => (v ? `Rp ${v.toLocaleString("id-ID")}` : ""),
      },
    ],
  })),
];

const EcomAggTable = ({ aggEcomData }) => (
  <Card
    title={
      <span style={{ fontWeight: 600 }}>E-Commerce Transaction Summary</span>
    }
    style={{
      width: "100%",
      margin: "30px 0",
      boxShadow: "0 2px 16px rgba(0,0,0,0.06)",
      borderRadius: 18,
    }}
  >
    <Table
      columns={aggEcomColumns}
      dataSource={buildTableData(aggEcomData)}
      pagination={false}
      bordered
      size="middle"
      scroll={{ x: "max-content" }}
      style={{ borderRadius: 16, background: "#fff" }}
    />
  </Card>
);

export default EcomAggTable;
